/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Category, CategoryType } from './Categories';

// Normalize BASE_URL to have a single leading slash and no trailing slash
export const BASE_URL = (() => {
  const raw = (import.meta.env.VITE_BASE_URL || '').toString();
  const trimmed = raw.replace(/^\/+|\/+$/g, '');
  return trimmed ? `/${trimmed}` : '';
})();

export const fetchUsersEndPoint = BASE_URL+'/query/users';
export const fetchServiceCasesEndPoint = BASE_URL+'/query/servicecases';
export const fetchproductStatisticsEndPoint = BASE_URL+'/query/productStatistics';
export const fetchUserCaseStatisticsEndPointEndPoint = BASE_URL+'/query/userCaseStatistics';
export const authenticateUserEndPoint = BASE_URL+'/api/User/Authenticate';
export const createNewUserEndPoint = BASE_URL +'/api/User/createNewUser';
export const forceAssignServiceCaseEndPoint = BASE_URL+'/api/User/AssignServicecase';
export const assignServiceCaseEndPoint = BASE_URL +'/api/User';
export const fetchLicensesEndPoint = BASE_URL +'/query/licenses';
export const fetchModulesEndPoint = BASE_URL +'/query/userrolemodules';
export const editUserEndPoint = BASE_URL +'/api/User/EditUser';
export const editRoleModuleEndPoint = BASE_URL +'/api/RoleModuleMapping/EditRoleModule/';
export const fetchServiceLevelsEndpoint = BASE_URL +'/query/serviceLevels';
export const fetchNotificationsEndpoint = BASE_URL +'/query/notifications';
export const markNotificationReadEndpoint = BASE_URL +'/api/Notification/MarkNotificationRead';
export const getServiceTicketEndpoint = BASE_URL +'/api/User/getServiceTicket';
export const fetchAuthorizationsEndpoint = BASE_URL + '/query/authorizations';
export const fetchFamiliesEndPoint = BASE_URL + '/query/family';
export const serviceManualEndPoint = BASE_URL + '/query/servicemanuls';
export const uploadServiceManualEndPoint = BASE_URL + '/api/ServiceManual/AddServiceManual';
export const retrieveServiceManualsEndPoint = BASE_URL + '/api/ServiceManual/GetServiceManuals';
export const getServiceManualDetailEndPoint = BASE_URL + '/api/ServiceManual/GetServiceManualDetail';
export const serialNumberClassificationManualEndpoint = BASE_URL + '/api/ServiceManual/GetSerialNumberClassification';
export const editServiceManualEndPoint = BASE_URL + '/api/ServiceManual/EditServiceManual';
export const getServiceManualDetailonNameEndPoint = BASE_URL + '/api/ServiceManual/GetServiceManualDetailonName';
export const uploadServiceBulletinEndPoint = BASE_URL + '/api/ServiceBulletin/UploadServiceBulletin';
export const retrieveServiceBulletinsEndPoint = BASE_URL + '/api/ServiceBulletin/GetServiceBulletins';
export const serialNumberClassificationBulletinEndpoint = BASE_URL + '/api/ServiceBulletin/GetSerialNumberClassification';
export const getServiceBulletinsURLEndPoint = BASE_URL + '/api/ServiceBulletin/GetURL';
export const bulletinNumberSearchEndpoint = BASE_URL + '/api/ServiceBulletin/GetServiceBulletinbyNumber';

export const firmTypeEndPoint = BASE_URL + '/query/firmtypes';
export const retrieveDownloadsEndPoint = BASE_URL + '/api/Downloads/GetDownloads';
export const getDownloadsDetailEndPoint = BASE_URL + '/api/Downloads/GetDownloadsDetail';
export const serialNumberClassificationDownloadsEndpoint = BASE_URL + '/api/Downloads/GetSerialNumberClassification';
export const serialNumberClassificationInstrumentConstantsEndpoint = BASE_URL + '/api/instrumentconstants/GetSerialNumberClassification';
export const getUploadIdInstrumentConstantsEndPoint = BASE_URL + '/api/instrumentconstants/GetUploadId';
export const partNumberSearchEndpoint = BASE_URL + '/api/instrumentconstants/GetPartNumberClassification';
export const editDownloadsEndPoint = BASE_URL + '/api/Downloads/EditDownloads';
export const getDownloadsDetailonNameEndPoint = BASE_URL + '/api/Downloads/GetDownloadsDetailonName';
export const uploadDownloadsEndPoint = BASE_URL + '/api/Downloads/Upload';
export const getPresignMultipleDownloads = BASE_URL + '/api/Downloads/PresignMultipleDownloads';

export const FileNameforInstrumentConstantsEndpoint = BASE_URL + '/api/instrumentconstants/GetConstantsforFileName';
export const getInstrumentConstantsEndPoint = BASE_URL + '/api/instrumentconstants/GetConstants';
export const getConstantsDetailonNameEndPoint = BASE_URL + '/api/instrumentconstants/GetDownloadsDetailonName';
export const uploadConstantsEndPoint = BASE_URL + '/api/instrumentconstants/Upload';
export const getPresignMultipleInstrumentConstants = BASE_URL + '/api/instrumentconstants/PresignMultipleInstrumentConstants';

export const retrieveLaborTimeGuideEndPoint = BASE_URL + '/api/LabourTimeGuide/GetLTGForProduct';
export const serialNumberClassificationLabourTimeGuideEndpoint = BASE_URL + '/api/LabourTimeGuide/GetSerialNumberClassification';
export const getsLaborTimeGuideDetailEndPoint = BASE_URL + '';
export const getsLaborTimeGuideForExport = BASE_URL + '/api/LabourTimeGuide/GetLTGForAllProduct';

export const GetGeneralServiceInformationEndpoint = BASE_URL + '/api/GeneralServiceInformation/GetGeneralServiceInfo';
export const GetGeneralServiceInformationURLEndpoint = BASE_URL + '/api/GeneralServiceInformation/GetURL';
export const GetGeneralServiceInformatioonNamenURLEndpoint = BASE_URL + '/api/GeneralServiceInformation/GetGeneralServiceInfoonName';

export const editGeneralServiceInformationEndpoint = BASE_URL + '/api/GeneralServiceInformation/EditGeneralServiceInfo';
export const uploadGeneralServiceInformationEndpoint = BASE_URL + '/api/GeneralServiceInformation/UploadGeneralServiceInfo';

export const getfatlasdownloaddataEndpoint = BASE_URL + '/api/GeneralServiceInformation/GetAtlasDownloadData';
export const getSubscriptionEndpoint = BASE_URL + '/api/EmailSubscription/GetSubscriptions';
export const manageEmailSubscriptionsEndpoint = BASE_URL + '/api/EmailSubscription/ManageEmailSubscriptions';

export const trackemailvisitEndpoint = BASE_URL + '/api/EmailSubscription/TrackEmailVisit';
export const emailnotificationtype = 'ServiceBulletinNotification';

export function getUrlByCategory(category: Category) {
  switch (category.type) {
    case CategoryType.ServiceCase:
      return fetchServiceCasesEndPoint;
    case CategoryType.License:
      return fetchLicensesEndPoint;
    case CategoryType.User:
      return fetchUsersEndPoint;
    case CategoryType.UserRole:
      return fetchModulesEndPoint;
    case CategoryType.TrainingAuthorization:
    case CategoryType.ProductAuthorization:
          return fetchAuthorizationsEndpoint;
      case CategoryType.Downloads:
          return serialNumberClassificationDownloadsEndpoint;
      case CategoryType.InstrumentConstants:
          return serialNumberClassificationInstrumentConstantsEndpoint;
    default:
      return '';
  }
}
export const authorizationRoute = '/authorization';
export const teamTrainingRoute = '/authorization/teamtraining';
export const teamproductRoute = '/authorization/teamproduct';
export const alltrainingRoute = '/authorization/alltraining';
export const allproductRoute = '/authorization/allproduct';
export const dashboardRoute = '/dashboard';
export const useradminRoute = '/useradmin';
export const userRoleRoute = useradminRoute + '/userrole';
export const licenseRoute = '/license';
export const editUserRoute = useradminRoute + '/edituser';
export const editUserRoleRoute = userRoleRoute + '/edituserrole';
export const notificationRoute = '/notification';
export const signInRoute = '/signin';
export const manualRoute = '/manual';
export const bulletinRoute = '/bulletins';
export const GSInfoRoute = '/gsinfo';
export const signincallbackRoute = '/signin-callback';
export const laborTimeGuideRoute = '/labortimeguide';
export const downloadsRoute = '/downloads';
export const instrumentConstantsRoute = '/instrumentConstants';
